import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Replay10Icon(props: IconProps) {
    return <Icon {...props} iconKey={"replay_10"}/>
}
